<template>
  <li 
    class="List__item"
    @click="navigate">
    <font-awesome-icon class="arrow" :icon="['fas', 'angle-right']" />
    <div>
      {{ name }}
      <MapBoxZoom 
        v-if="readmore !== ''"
        :type="type"
        :slug="slug" 
        :label="readmore" />
    </div>
  </li>
</template>

<script>

import MapBoxZoom from '@/components/buttons/MapBoxZoom';

export default {
  name: 'ListItem',
  components: {
    MapBoxZoom
  },
  props: {
    slug: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    to: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    readmore: {
      type: String,
      default: 'Lees meer'
    }
  },
  methods: {
    navigate() {
      this.$router.push(this.to);
    }
  }
}
</script>

<style lang="scss">
.List__item {
  font-family: $font_nav;
  font-size: 16px;
  padding: 0px 16px 0px 32px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $color_primary;
  user-select: none;
  overflow: none;
  position: relative;
  margin-bottom: 16px;

  &:hover {
    color: $metro_oranje;
  }

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 28px);
    // padding-top: 8px;
    // padding-bottom: 8px;
  }
  .arrow {
    margin-right: 8px;
  }
  .MapBoxZoom {
    margin-left: 8px;
  }
}

</style>
